import script from "./goodsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsDetail.vue?vue&type=script&setup=true&lang=js"

import "./goodsDetail.vue?vue&type=style&index=0&id=3fcb2fdb&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fcb2fdb"]])

export default __exports__